import { observer } from 'mobx-react';
import React from 'react';
import { CardContent, Card, Grid, GridColumn, ListItem, Separator, Image, TooltipToggle, Tooltip } from 'telia-front-react';
import { getImageSrcset } from '../../../util/PathUtil';
const getImageProps = (image, width = 300, alt) => ({
    srcset: getImageSrcset(['300', '600'], `v1651752420/tweb/tradein/${image}`, false),
    width,
    height: width,
    alt
});
const TooltipWithToggle = ({ tooltip, translate }) => {
    if (!tooltip) {
        return null;
    }
    const id = tooltip === null || tooltip === void 0 ? void 0 : tooltip.label.replace(/\./g, '-');
    return (React.createElement(React.Fragment, null,
        React.createElement(TooltipToggle, { id: id }, translate(tooltip.label)),
        React.createElement(Tooltip, { referenceElement: `#${id}` }, translate(tooltip.content))));
};
const TradeInConditionBulletpoint = (props) => {
    const { tradeInStore, label, bulletPointNr, condition, translate, isLast } = props;
    const images = tradeInStore.getConditionBulletPointImages(condition, bulletPointNr);
    const id = `image-${condition}-${bulletPointNr}`;
    const tooltipBefore = tradeInStore.getTooltipBefore(condition, bulletPointNr);
    const tooltipAfter = tradeInStore.getTooltipAfter(condition, bulletPointNr);
    const renderedLabel = (React.createElement(React.Fragment, null,
        React.createElement(TooltipWithToggle, { tooltip: tooltipBefore, translate: translate }),
        " ",
        translate(label),
        " ",
        React.createElement(TooltipWithToggle, { tooltip: tooltipAfter, translate: translate })));
    return (React.createElement(ListItem, { className: "h5", key: bulletPointNr }, images.length > 0 ? (React.createElement(React.Fragment, null,
        renderedLabel,
        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
        React.createElement(Grid, null, images.map(([image, type]) => (React.createElement(GridColumn, { key: image, width: ['xs-12', 'sm-6'] },
            React.createElement(Card, { badgeTop: {
                    size: 'large',
                    purpose: type,
                    icon: type === 'error' ? '#alert-round' : '#check-round'
                }, type: type, padding: "none" },
                React.createElement(CardContent, { background: "neutral-bg-level-2" },
                    React.createElement(Image, { key: id, ...getImageProps(image, 300, `${translate(label)}`), style: { width: '100%' } }))))))),
        !isLast && React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }))) : (renderedLabel)));
};
export default observer(TradeInConditionBulletpoint);
